import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { STATIC_KEYWORDS } from "../../../../constants";
import { getCategoryAndSubCategory, getTemplateName } from "../../../../ga-utils";

import "./tags.m.css";
function StoryTags({ tags = [], borderTop = true, story }) {
  const nonEntityTags = tags.filter((tag) => tag["tag-type"] !== "Entity");
  const qtConfig = useSelector((state) => get(state, ["qt", "config"], {}));
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], {}));

  const trackEvent = (tagName, position) => {
    const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, pageType, qtConfig, story);
    const templateName = getTemplateName(story?.["story-template"] || pageType);

    try {
      if (typeof window !== "undefined" && window.dataLayer) {
        window.dataLayer.push({
          event: "dl_story_interactions",
          event_action: "related_tag_clicks",
          link_text: tagName,
          link_position: position + 1,
          category: category,
          sub_category: subCategory,
          content_id: contentId,
          template_name: templateName,
          platform: window.innerWidth >= 768 ? "desktop" : "mobile",
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  return nonEntityTags?.length ? (
    <>
    <div styleName="download_app">Explore the world of business like never before with the Fortune India app. From breaking news to in-depth features, experience it all in one place. <a href="/apps" title="Download App Now" target="_blank">Download Now</a></div>
    <div styleName={`tags-wrapper ${!borderTop ? "no-border-top" : ""}`} className="tags-wrapper">
      <div styleName="tags-title">{STATIC_KEYWORDS.RELATED_TAGS}</div>
      <div styleName="tags-element-wrapper">
        {nonEntityTags.map((tag, index) => (
          <div styleName="tag-element" key={index}>
            <Link
              href={`/topic/${tag.slug}`}
              className="story-tag"
              disableAjaxLinks={true}
              onMouseDown={() => trackEvent(tag.name, index)}
              onTouchStart={() => trackEvent(tag.name, index)}
            >
              {tag.name}
            </Link>
          </div>
        ))}
      </div>
    </div>
    </>
  ) : <div styleName="download_app">Explore the world of business like never before with the Fortune India app. From breaking news to in-depth features, experience it all in one place. <a href="/apps" title="Download App Now" target="_blank">Download Now</a></div>;
}

export { StoryTags };

StoryTags.propTypes = {
  tags: PropTypes.array,
  borderTop: PropTypes.bool,
};
